import { useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";

interface CollapsibleSectionProps {
  title: string;
  subtitle?: string;
  badge?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
  className?: string;
}

export function CollapsibleSection({
  title,
  subtitle,
  badge,
  defaultOpen = false,
  children,
  className = "",
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section
      className={`overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm ${className}`}
    >
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex w-full items-center gap-2 px-2 py-1.5 text-start transition hover:bg-godo-surface/80"
        aria-expanded={open}
      >
        <ChevronDown
          className={`h-5 w-5 shrink-0 text-godo-accent transition ${open ? "rotate-180" : ""}`}
          aria-hidden
        />
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-bold text-godo-primary">{title}</span>
            {badge}
          </div>
          {subtitle && (
            <p className="mt-0.5 text-xs text-godo-muted-green">{subtitle}</p>
          )}
        </div>
      </button>
      {open && <div className="border-t border-slate-100 px-2 py-2">{children}</div>}
    </section>
  );
}
